export default __webpack_public_path__ + "static/media/20210227_101041.e45f36a7.jpg";